const authStore = {
  auth: {
    name: '',
    permissions: [],
    token: null,
  },
}

export default authStore
